/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedBlurbPcs_user$ref = any;
type PdpSharedBlurbReturns_user$ref = any;
type PdpSharedBlurbShipping_user$ref = any;
type PdpSharedBlurbSupportNumber_user$ref = any;
type PdpSharedBlurbTradeRequestAppointment_user$ref = any;
export type PdpRespSidebarBlurbs_user$ref = any;
export type PdpRespSidebarBlurbs_user = {
    readonly " $fragmentRefs": PdpSharedBlurbPcs_user$ref & PdpSharedBlurbShipping_user$ref & PdpSharedBlurbReturns_user$ref & PdpSharedBlurbSupportNumber_user$ref & PdpSharedBlurbTradeRequestAppointment_user$ref;
    readonly " $refType": PdpRespSidebarBlurbs_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbTradeRequestAppointment_user",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'fc4ad87d831b7ba1d9a2046c16e83f24';
export default node;
